<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Create from './Create.vue'
	import ScheduleCreate from './../../schedules/views/Create.vue'

	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'create': Create,
			'schedule-create': ScheduleCreate,
			'datatable': Datatable,
		},
		data () {
			return {
				resource: 'tasks',
				data: [],

				dataFilter: {
					date: null,
					project_id: null,
					user_id: null,
					status: null
				},

				dataExport: {
					url: 'admin/projects/tasks/export',
					filter: {
					},
					show: false,
					status: null,
				},

				selected: [],
			}
		},
		mounted() {
			this.dataFilter.status = this.$route.params.status
		},
		watch: {
			'$route.params.status': function(value) {
				this.clearDataFilter()
				this.dataFilter.status = value
				this.reload()
			},
		},
		created () {
			this.init()
		},
		methods: {
			init() {
			},
			clearDataFilter() {
				this.dataFilter.date = null
				this.dataFilter.project_id = null
				this.dataFilter.user_id = null
				this.dataFilter.status = null
			},
			//-- Evento para actualizar los items seleccionados desde el componente Action.vue
			itemSelected(data) {
				this.selected = data
			},
			//-- Evento para actualizar la data filtrada
			filter(data) {
				this.dataExport.filter = this.$refs.filtercomponent.filter
				this.data = data
				if(this.data.length > 0) {
					this.dataExport.show = true
				} else {
					this.dataExport.show = false
				}
			},
			reload: function() {
				this.$refs.datatable.reload()
				this.selected = []
			},
			// SCHEDULES
			openCreateSchedule: function(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open()
			},

		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/views/Index.vue